import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@recruitee/i18n';
import {
  ButtonComponent,
  ButtonLoadingDirective,
  CheckboxComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  FormErrorDirective,
  FormFieldComponent,
  HeadingComponent,
  InputComponent,
  LabelComponent,
  SelectComponent,
} from '@recruitee/user-interface';

import { NewCompanyDialogComponent } from '../dialogs/new-company-dialog/new-company-dialog.component';

@NgModule({
  imports: [
    ButtonComponent,
    ButtonLoadingDirective,
    CheckboxComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    FormErrorDirective,
    FormFieldComponent,
    HeadingComponent,
    InputComponent,
    LabelComponent,
    SelectComponent,
    TranslatePipe,
    NgIf,
    ReactiveFormsModule,
    NewCompanyDialogComponent,
  ],
  exports: [NewCompanyDialogComponent],
})
export class RtNewCompanyDialogSharedModule {}

export { NewCompanyDialogComponent };
